import React, { useState } from "react";
import style from "./style.module.scss";
import { FakeLoader } from "components";

const Image = ({ src, alt }) => {
  const [loading, setLoading] = useState(true);

  return (
    <>
      {loading && <div className={`${style.loader}`}>
          <FakeLoader withMask/>
      </div>}
      <img
        src={src}
        alt={alt}
        onLoad={() => setLoading(false)}
        className={`${style.image} ${loading ? style.hidden : style.visible}`}
      />
    </>
  );
};

export default Image;
